import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { loginBroker } from "../../redux/auth/actions";
import Loader from "../Loader/Loader";
import { useEffect, useState } from "react";
import _ from "lodash";

const SocialLoginComp = (props) => {

    const {setIsSocial} = props;
    const dispatch = useDispatch();

    const authBroker = useSelector((state) => state.auth.authBroker);

    const [isLoading, setIsLoading] = useState(false);
    const [formError, setFormError] = useState("");

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => {
          console.log('Login Success:', codeResponse)
    
          setIsLoading(true);
          dispatch(
            loginBroker({
              action: "realtor_login_google",
              access_token: codeResponse.access_token
            })
          );
        },
        onError: (error) => { alert('Google Login Failed:', error) },
    
      });
    
      const logOut = () => {
        googleLogout();
        // setProfile(null);
      };

      useEffect(() => {
        console.log(authBroker);
        if (!_.isEmpty(authBroker)) {
          setIsLoading(false);
          setFormError("");
        }
        
        if (authBroker?.status === "error") {
          // console.log('authBroker', auth?.error?.message, authBroker?.error?.message)
          window.captureMyEvents("loginFailed", {
            message: authBroker?.error?.message,
          });
          setFormError(authBroker?.error?.message);
          
        }
      }, [authBroker]);

    return (<>
      <Loader start={isLoading} />
        <div className="text-center ">
            <div className="btn btn-primary google-login-btn" onClick={() => login()}>Sign in with Google <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="25px" height="25px"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/></svg> </div>
        </div>
        <div className="text-center mt-1 " style={{ color: "red" }}>{formError}</div>
       {false && <div onClick={()=>{setIsSocial(0)}} title="Back" className="back-btn-google-login text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#6941C6" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </div>}
    </>)


}
export default SocialLoginComp